import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { SamwinSkillsState } from 'src/app/store/samwin/samwin-skills/samwin-skills.state';
import { Skill } from 'src/app/store/samwin/samwin-skills/skill';
import { SkillConstants } from 'src/app/store/samwin/samwin-skills/skill-constants';
import { SkillConfigurationRemoteDto } from 'src/generated/signalR/skill-configuration-remote-dto';

@Component({
   selector: 'samweb-skill-short-info',
   templateUrl: './skill-short-info.component.html',
   styleUrls: ['./skill-short-info.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillShortInfoComponent implements OnInit {
   constructor(private store: Store) {}

   @Input()
   public skillConfiguration: SkillConfigurationRemoteDto;

   @Input()
   public skills: Skill[];

   @Input()
   public userId: number;

   @Input()
   public visualizeLoggedOnState: boolean;

   @Input()
   public searchValue: string[];

   public loggedOnUsers$: Observable<boolean>;

   public isOverallSkill = false;

   ngOnInit() {
      if (this.visualizeLoggedOnState && this.userId > 0) {
         this.loggedOnUsers$ = this.store.select(SamwinSkillsState.isUserLoggedOnToSkill).pipe(
            distinctUntilChanged((prev, curr) => _.isEqual(prev, curr)),
            map((fn) => fn(this.skillConfiguration.id, this.userId))
         );
      }
      this.isOverallSkill = this.skillConfiguration?.id === SkillConstants.OVERALL_SKILL_ID;
   }
}
